var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"katex-text",domProps:{"innerHTML":_vm._s(_vm.katexHtml())}})
}
var staticRenderFns = []

export { render, staticRenderFns }